import { Address } from '@/models/common/address';

export enum OrderShippingAddressType {
    Pickup,
    Delivery,
    ReceiveDigitally,
}

export class OrderShippingAddress {
    public type?: OrderShippingAddressType;
    public name?: string;
    public email?: string;
    public phoneNo?: string;
    public address?: Address;
    public remarks?: string;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        const orderShippingAddressTypeKeys: any = {};
        for (const x in OrderShippingAddressType) {
            if (OrderShippingAddressType.hasOwnProperty(x)) { orderShippingAddressTypeKeys[OrderShippingAddressType[x]] = x; }
        }

        Object.assign(this,
            json,
            {
                address: json.address ? new Address(json.address) : undefined,
                type: OrderShippingAddressType[orderShippingAddressTypeKeys[+json.type]],
            },
        );
    }

    public clone(): OrderShippingAddress {
        const orderShippingAddress: OrderShippingAddress = new OrderShippingAddress();

        orderShippingAddress.type = this.type;
        orderShippingAddress.name = this.name;
        orderShippingAddress.email = this.email;
        orderShippingAddress.phoneNo = this.phoneNo;
        orderShippingAddress.address = this.address ? this.address.clone() : undefined;
        orderShippingAddress.remarks = this.remarks;

        return orderShippingAddress;
    }
}
